import { type FC, useMemo } from 'react';
import { TObjectBulkEditJob } from 'types/objectJob.type';
import BulkEditStartJobButton, {
  useJobBulkEditProps,
} from '../../../BulkEditStartJobButton';
import JobDetailHeader from '../components/JobDetailHeader';
import JobExecutionResult from '../components/JobExecutionResult';
import OperationInfo from '../components/OperationInfo';

type Props = {
  data: TObjectBulkEditJob;
};

const BulkEditDetails: FC<Props> = ({ data }: Props) => {
  const bulkEditProps = useJobBulkEditProps(data);

  const newOperationButton = useMemo(
    () => (
      <BulkEditStartJobButton {...bulkEditProps} type="default" size="middle">
        Start new operation ({bulkEditProps.jobSummary.total} objects)
      </BulkEditStartJobButton>
    ),
    [bulkEditProps]
  );
  return (
    <>
      <JobDetailHeader job={data} newOperationButton={newOperationButton} />
      <OperationInfo job={data} />
      <JobExecutionResult job={data} />
    </>
  );
};

export default BulkEditDetails;
